export enum EFocusView {
  US_CONTINENTAL = 'USA (Continental)',
  US_PUERTO_RICO = 'USA (Puerto Rico)',
  US_ALASKA = 'USA (Alaska)',
  US_HAWAII = 'USA (Hawaii)',
  US_SOUTH = 'USA (South)',
  US_SOUTHEAST = 'USA (Southeast)',
  US_SOUTHWEST = 'USA (Southwest)',
  US_WEST = 'USA (West)',
  US_MIDWEST = 'USA (Midwest)',
  US_NORTHEAST = 'USA (Northeast)',
  EU_ITALY = 'Italy',
  MIDDLE_EAST = 'Middle East',
  EUROPE = 'Europe',
}
